module.exports = __webpack_public_path__ + "static/media/login-back-adm-tablet.a661e0c1.jpg";